export const SET_CLASS_EDITOR_VALUE = "SET_CLASS_EDITOR_VALUE";

export const setClassEditorValue = (classEditorValue) => ({
  type: SET_CLASS_EDITOR_VALUE,
  payload: classEditorValue,
});
